var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Button, Chip, Grid, Link, Typography } from '@mui/material';
import { GRID_AGGREGATION_ROOT_FOOTER_ROW_ID, gridClasses } from '@mui/x-data-grid-premium';
import dayjs from 'dayjs';
import { useMemo, useState } from 'react';
import { DeleteSvgIcon } from '../../../assets/customIcons';
import { EditableGridActions } from '../../../builderPackage/components/editableDataGrid/components/editableGridToolbar';
import GridSearchSelect from '../../../builderPackage/components/editableDataGrid/components/gridSearchSelect';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { RowModeIds } from '../../../builderPackage/components/editableDataGrid/editableDataGrid.entity';
import { MuiStack } from '../../../components';
import { StatusEnum } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { showNotification } from '../../../redux/commonSlice';
import { setReducerState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { bajajPrimaryBlue } from '../../../theme/palette';
import { getStatusColor } from '../../../theme/statusColors';
import { convertNumberToDecimal } from '../../../utils/utils';
import { REG } from '../../../utils/validationHelper';
import TaxDetailsPopup from '../../jobCard/partGridPopups/taxDetailsPopup';
import { getPriceDetailsWithTax, getTax, getTechnicianList, pauseReasonListAPICall, reworkHistoryApiCall, validateDeletePartLabour } from '../services/apiCalls';
import { GridValidations, JobCardKeys } from '../services/entity';
import { partLabourSearchSelectFilterOperators, searchSelectSortComparator } from '../utils/utils';
var JobcardLabourGrid = function (props) {
    var _a;
    var _crud$JobCardKeys$Con, _crud$JobCardKeys$Con2, _documentDetailsGetBy;
    var onChange = props.onChange, value = props.value, error = props.error, _b = props.name, name = _b === void 0 ? 'labourDetails' : _b, disabled = props.disabled;
    var currValue = useMemo(function () {
        var _value$name;
        return (_value$name = value[name]) === null || _value$name === void 0 ? void 0 : _value$name.filter(function (item) { return !item.IsDeleted; });
    }, [value[name]]);
    var crud = useAppSelector(function (state) { return state.crud; });
    var documentDetailsGetById = crud.documentDetailsGetById;
    var configurationData = (_crud$JobCardKeys$Con = (_crud$JobCardKeys$Con2 = crud[JobCardKeys.Configurations]) === null || _crud$JobCardKeys$Con2 === void 0 ? void 0 : _crud$JobCardKeys$Con2.data) !== null && _crud$JobCardKeys$Con !== void 0 ? _crud$JobCardKeys$Con : [];
    var _c = useState({}), drawerData = _c[0], setDrawerData = _c[1];
    var dispatch = useAppDispatch();
    // only UAT v2.5
    // const [labourModalProps, setLabourModalProps] = useState<ResponseObject>();
    var getStatus = function (name) {
        var _crud$JobCardKeys$Lab;
        return (_crud$JobCardKeys$Lab = crud[JobCardKeys.LabourStatusList]) === null || _crud$JobCardKeys$Lab === void 0 || (_crud$JobCardKeys$Lab = _crud$JobCardKeys$Lab.data) === null || _crud$JobCardKeys$Lab === void 0 ? void 0 : _crud$JobCardKeys$Lab.find(function (item) { return (item === null || item === void 0 ? void 0 : item.Key) === name; });
    };
    var onCloseDrawer = function () {
        setDrawerData(_objectSpread(_objectSpread({}, drawerData), {}, {
            openDrawer: false
        }));
    };
    var handleDrawerOpen = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _params$row, request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        JobCardId: params === null || params === void 0 ? void 0 : params.id,
                        JobCardDetailId: params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.JobCardDetailId
                    };
                    return [4 /*yield*/, reworkHistoryApiCall({
                            request: request
                        })];
                case 1:
                    _a.sent();
                    setDrawerData(_objectSpread(_objectSpread({}, drawerData), {}, {
                        openDrawer: true,
                        labourRowData: params === null || params === void 0 ? void 0 : params.row,
                        onClose: onCloseDrawer
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var getConfigurationValue = function (key) {
        configurationData.filter(function (data) {
            if (data.Key === key) {
                return data.Value;
            }
            return !data.Value;
        });
        return true;
    };
    // only UAT v2.5
    // const saveRatioBillingDetails = async (ratioData: any, currentRow: any) => {
    //     console.log("currentRow", currentRow);
    //     let ratioDataBody = ratioData.map((item: any, index: number) => {
    //         return {
    //             ServiceTypeBillingRatioSettingId: item.ServiceTypeBillingRatioSettingId,
    //             "HeaderServiceTypeId": documentDetailsGetById?.data?.RepairTypeId,
    //             "LineServiceTypeId": currentRow.ServiceTypeId,
    //             "EntityId": currentRow.EntityId,
    //             "ChildId": currentRow.ChildId,
    //             "Percentage": item.PercentageValue,
    //             "IsChanged": false,
    //             "ServiceTypeBillingRatioSettingSchemaId": item.SchemaId
    //         }
    //     })
    //     const requestBody: any = {
    //         JobcardId: id,
    //         JobCardDetailBillingRatios: ratioDataBody
    //     }
    //     const Response = await dispatch(getListAPI({ key: '', url: upsertRatioBillingDetailsUrl, request: requestBody }));
    //     console.log("Response", Response);
    //     if (Response?.payload?.value?.success) {
    //         dispatch(
    //             showNotification({
    //                 isOpen: true,
    //                 message: "saved successfully.",
    //                 type: "success"
    //             })
    //         );
    //     }
    // }
    var labourColumns = [{
            type: 'searchSelect',
            field: 'ChildName',
            headerName: 'Labour name & code',
            minWidth: 300,
            renderCell: function (params) {
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation) {
                    return 'Total';
                }
                else {
                    var _params$row$ChildName, _params$row2, _params$row3, _params$row4, _params$row5;
                    return /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "caption"
                    }, (_params$row$ChildName = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.ChildName) !== null && _params$row$ChildName !== void 0 ? _params$row$ChildName : ""), /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "caption",
                        color: 'secondary'
                    }, params !== null && params !== void 0 && (_params$row3 = params.row) !== null && _params$row3 !== void 0 && _params$row3.ChildCode ? "#".concat(params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ChildCode) : ""), (params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.LabourStatus) == 'Rework' && /*#__PURE__*/ React.createElement(Button, {
                        variant: "text",
                        onClick: function () { return handleDrawerOpen(params); }
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: '10px',
                        fontWeight: 400,
                        color: bajajPrimaryBlue,
                        sx: {
                            textDecoration: 'underline'
                        }
                    }, " Rework History"))));
                }
            },
            valueGetter: function (value, row) { return (row === null || row === void 0 ? void 0 : row.ChildName) + ' ' + (row === null || row === void 0 ? void 0 : row.ChildCode); },
            editable: false,
            aggregable: false
            // only UAT v2.5
            // getListData: LabourListAPI,
            // apiKey: 'LabourList',
            // getOptionLabel: (option: any) => option?.DisplayName ?? '',
            // valueFormatter: (value: any) => value?.DisplayName ?? '',
            // valueSetter(value: any, row) {
            //     return {
            //         ...row,
            //         ChildName: value?.DisplayName ?? '',
            //         ChildId: value.LabourId ?? null,
            //         ChildCode: value?.Code ?? '',
            //     };
            // },
            // valueGetter(val, row) {
            //     return {
            //         DisplayName: row?.ChildName ?? '',
            //         ChildId: row?.ChildId ?? null,
            //         ChildCode: row?.ChildCode ?? '',
            //     }
            // },
        }, {
            type: 'string',
            field: 'Description',
            headerName: 'Description',
            width: 150,
            editable: false,
            aggregable: false
        }, {
            type: 'string',
            field: 'HSNSACCode',
            headerName: 'SAC Code',
            width: 150,
            editable: false,
            aggregable: false
        },
        // {
        //     type: 'string',
        //     field: 'UnitOfMeasurementName',
        //     headerName: 'UOM',
        //     width: 150,
        // },
        {
            type: 'searchSelect',
            field: 'ServiceTypeName',
            headerName: 'Service type',
            minWidth: 300,
            editable: false,
            aggregable: false
            // only UAT v2.5.0
            // getListData: warrantyServiceTypeListAPI,
            // apiKey: 'labourServiceTypeList',
            // getOptionLabel: (option: any) => option?.DisplayName ?? '',
            // valueFormatter: (value: any) => value?.DisplayName ?? '',
            // valueSetter(value: any, row) {
            //     return {
            //         ...row,
            //         ServiceTypeName: value?.DisplayName ?? '',
            //         ServiceTypeId: value?.ServiceTypeId ?? null,
            //     };
            // },
            // valueGetter(val, row) {
            //     return {
            //         DisplayName: row?.ServiceTypeName ?? '',
            //         ServiceTypeId: row?.ServiceTypeId ?? null,
            //     }
            // },
        }, {
            type: 'searchSelect',
            field: 'TechnicianName',
            headerName: 'Technician',
            getListData: getTechnicianList,
            apiKey: 'labourTechnicianList',
            apiRequest: {
                WorkingOrganizationId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.OrganizationId
            },
            editable: true,
            placeholder: "Select Technician",
            minWidth: 250,
            getOptionLabel: function (option) { return option !== null && option !== void 0 && option.FirstName || option !== null && option !== void 0 && option.LastName ? (option === null || option === void 0 ? void 0 : option.FirstName) + " " + (option === null || option === void 0 ? void 0 : option.LastName) : ''; },
            valueFormatter: function (value) { return value !== null && value !== void 0 && value.FirstName || value !== null && value !== void 0 && value.LastName ? (value === null || value === void 0 ? void 0 : value.FirstName) + " " + (value === null || value === void 0 ? void 0 : value.LastName) : ''; },
            valueSetter: function (value, row) {
                var _value$id;
                if (!value) {
                    return _objectSpread(_objectSpread({}, row), {}, {
                        ServiceStartDateTime: null,
                        ServiceEndDateTime: null,
                        TechnicianName: null,
                        TechnicianId: null,
                        TechnicianFamilyName: null
                    });
                }
                return _objectSpread(_objectSpread({}, row), {}, {
                    TechnicianName: value === null || value === void 0 ? void 0 : value.FirstName,
                    TechnicianFamilyName: value === null || value === void 0 ? void 0 : value.LastName,
                    TechnicianId: (_value$id = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id !== void 0 ? _value$id : null
                });
            },
            valueGetter: function (val, row) {
                var _row$TechnicianName, _row$TechnicianFamily;
                if (row !== null && row !== void 0 && row.TechnicianName || row !== null && row !== void 0 && row.TechnicianId)
                    return {
                        FirstName: (_row$TechnicianName = row === null || row === void 0 ? void 0 : row.TechnicianName) !== null && _row$TechnicianName !== void 0 ? _row$TechnicianName : '',
                        LastName: (_row$TechnicianFamily = row === null || row === void 0 ? void 0 : row.TechnicianFamilyName) !== null && _row$TechnicianFamily !== void 0 ? _row$TechnicianFamily : '',
                        id: row === null || row === void 0 ? void 0 : row.TechnicianId
                    };
                return null;
            },
            aggregable: false,
            filterOperators: partLabourSearchSelectFilterOperators,
            sortComparator: searchSelectSortComparator
        }, {
            type: 'number',
            field: 'Quantity',
            headerName: 'Units',
            width: 120,
            editable: false,
            valueFormatter: function (value) {
                return convertNumberToDecimal(value);
            },
            filterable: false
            // only UAT v2.5
            // valueSetter(value: any, row) {
            //     return {
            //         ...row,
            //         Amount: row?.Rate * value || 0,
            //         TaxAmount: row?.Rate * value || 0,
            //         Quantity: value
            //     };
            // },
        }, {
            type: 'number',
            field: 'Rate',
            headerName: 'Rate(₹)',
            width: 120,
            editable: true,
            filterable: false,
            renderCell: function (_ref) {
                var _row$SavedPriceWithTa;
                var row = _ref.row, id = _ref.id;
                if (id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
                    return undefined;
                }
                return convertNumberToDecimal(row === null || row === void 0 || (_row$SavedPriceWithTa = row.SavedPriceWithTax) === null || _row$SavedPriceWithTa === void 0 ? void 0 : _row$SavedPriceWithTa.Rate);
            }
        }, {
            type: 'dateTime',
            field: 'ServiceStartDateTime',
            headerName: 'Start Date & Time',
            editable: getConfigurationValue(JobCardKeys.RestrictUserEditingDate),
            width: 170,
            headerAlign: 'left',
            aggregable: false,
            renderCell: function (params) {
                var value = params.value;
                if (!value || (params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation)
                    return '';
                var dateStr = dayjs(value).format('DD MMM, YYYY');
                var timeStr = dayjs(value).format('h:mm A');
                return /*#__PURE__*/ React.createElement("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    }
                }, dateStr), /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        fontSize: 'sm',
                        color: 'text.secondary'
                    }
                }, timeStr));
            },
            valueGetter: function (value, row) {
                return value ? new Date(value) : null;
            }
        }, {
            type: 'dateTime',
            field: 'ServiceEndDateTime',
            headerName: 'End Date & Time',
            editable: getConfigurationValue(JobCardKeys.RestrictUserEditingDate),
            width: 170,
            headerAlign: 'left',
            aggregable: false,
            renderCell: function (params) {
                var value = params.value;
                if (!value || (params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation)
                    return '';
                var dateStr = dayjs(value).format('DD MMM, YYYY');
                var timeStr = dayjs(value).format('h:mm A');
                return /*#__PURE__*/ React.createElement("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    }
                }, dateStr), /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        fontSize: 'sm',
                        color: 'text.secondary'
                    }
                }, timeStr));
            },
            valueGetter: function (value, row) {
                return value ? new Date(value) : null;
            }
        }, {
            type: 'searchSelect',
            field: 'StatusId',
            headerName: 'Status',
            width: 170,
            aggregable: false,
            // getListData: getWorkDistributionStatusList,
            // apiKey: 'labourStatusList',
            // apiRequest: { SystemName: "JobCardDetail" },
            editable: true,
            getOptionLabel: function (option) {
                var _option$DisplayName;
                return (_option$DisplayName = option === null || option === void 0 ? void 0 : option.DisplayName) !== null && _option$DisplayName !== void 0 ? _option$DisplayName : '';
            },
            valueFormatter: function (value) {
                var _value$DisplayName;
                return (_value$DisplayName = value === null || value === void 0 ? void 0 : value.DisplayName) !== null && _value$DisplayName !== void 0 ? _value$DisplayName : '';
            },
            renderEditCell: function (params) {
                var _crud$JobCardKeys$Lab2, _params$row6;
                var allOptions = ((_crud$JobCardKeys$Lab2 = crud[JobCardKeys.LabourStatusList]) === null || _crud$JobCardKeys$Lab2 === void 0 ? void 0 : _crud$JobCardKeys$Lab2.data) || [];
                var currentStatusId = (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.StatusId;
                var filteredOptions = allOptions.filter(function (option) { return (option === null || option === void 0 ? void 0 : option.id) !== currentStatusId; });
                return /*#__PURE__*/ React.createElement(GridSearchSelect, _extends({}, params, {
                    colDef: _objectSpread(_objectSpread({}, params.colDef), {}, {
                        valueOptions: filteredOptions
                    })
                }));
            },
            renderCell: function (params) {
                var _params$row7, _params$row8;
                if (!value || (params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation)
                    return '';
                return params !== null && params !== void 0 && params.value ? /*#__PURE__*/ React.createElement(Chip, _extends({
                    label: params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 ? void 0 : _params$row7.StatusName,
                    size: "small",
                    shape: "rounded",
                    id: 'status'
                }, getStatusColor((params === null || params === void 0 || (_params$row8 = params.row) === null || _params$row8 === void 0 ? void 0 : _params$row8.StatusName) || ''))) : null;
            },
            valueSetter: function (value, row) {
                var _value$DisplayName2, _value$id2;
                var serviceStartDateTime;
                var serviceEndDateTime;
                var newStatus = value === null || value === void 0 ? void 0 : value.DisplayName;
                var prevStatus = row === null || row === void 0 ? void 0 : row.StatusName;
                var isCompleted = newStatus === StatusEnum.Completed;
                var isPaused = newStatus === StatusEnum.Pause;
                var isAwaiting = newStatus === StatusEnum.Awaiting;
                var wasCompleted = prevStatus === StatusEnum.Completed;
                var wasPaused = prevStatus === StatusEnum.Pause;
                var wasStart = prevStatus === StatusEnum.Start;
                var hasStartTime = !!(row !== null && row !== void 0 && row.ServiceStartDateTime);
                var hasEndTime = !!(row !== null && row !== void 0 && row.ServiceEndDateTime);
                if (newStatus === StatusEnum.Start) {
                    serviceStartDateTime = new Date();
                    serviceEndDateTime = null;
                }
                else if ((isCompleted || isPaused) && !hasStartTime) {
                    serviceStartDateTime = new Date();
                    serviceEndDateTime = new Date();
                }
                else if (isAwaiting) {
                    serviceStartDateTime = null;
                    serviceEndDateTime = null;
                }
                else {
                    serviceStartDateTime = row === null || row === void 0 ? void 0 : row.ServiceStartDateTime;
                    if (isCompleted && !hasEndTime || wasCompleted && isPaused || wasPaused && isCompleted || wasStart && isPaused) {
                        serviceEndDateTime = new Date();
                    }
                    else {
                        var _row$ServiceEndDateTi;
                        serviceEndDateTime = (_row$ServiceEndDateTi = row === null || row === void 0 ? void 0 : row.ServiceEndDateTime) !== null && _row$ServiceEndDateTi !== void 0 ? _row$ServiceEndDateTi : null;
                    }
                }
                return _objectSpread(_objectSpread({}, row), {}, {
                    StatusName: (_value$DisplayName2 = value === null || value === void 0 ? void 0 : value.DisplayName) !== null && _value$DisplayName2 !== void 0 ? _value$DisplayName2 : '',
                    StatusId: (_value$id2 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id2 !== void 0 ? _value$id2 : null,
                    PauseReasonName: (value === null || value === void 0 ? void 0 : value.DisplayName) !== StatusEnum.Pause ? null : row === null || row === void 0 ? void 0 : row.PauseReasonName,
                    PauseReasonId: (value === null || value === void 0 ? void 0 : value.DisplayName) !== StatusEnum.Pause ? null : row === null || row === void 0 ? void 0 : row.PauseReasonId,
                    PauseRemarks: (value === null || value === void 0 ? void 0 : value.DisplayName) !== StatusEnum.Pause ? null : row === null || row === void 0 ? void 0 : row.PauseRemarks,
                    StatusKey: value === null || value === void 0 ? void 0 : value.DisplayName,
                    ServiceStartDateTime: serviceStartDateTime,
                    ServiceEndDateTime: serviceEndDateTime
                });
            },
            valueGetter: function (val, row) {
                var _row$StatusName, _row$StatusId;
                return {
                    DisplayName: (_row$StatusName = row === null || row === void 0 ? void 0 : row.StatusName) !== null && _row$StatusName !== void 0 ? _row$StatusName : '',
                    id: (_row$StatusId = row === null || row === void 0 ? void 0 : row.StatusId) !== null && _row$StatusId !== void 0 ? _row$StatusId : null,
                    Key: row === null || row === void 0 ? void 0 : row.StatusKey
                };
            },
            filterOperators: partLabourSearchSelectFilterOperators,
            sortComparator: searchSelectSortComparator
        }, {
            type: 'searchSelect',
            field: 'PauseReasonName',
            headerName: 'Pause Reason',
            minWidth: 300,
            headerAlign: 'left',
            getListData: pauseReasonListAPICall,
            apiKey: 'PauseReasonData',
            apiRequest: {
                SystemName: "JobCardDetail"
            },
            editable: true,
            getOptionLabel: function (option) {
                var _option$Name;
                return (_option$Name = option === null || option === void 0 ? void 0 : option.Name) !== null && _option$Name !== void 0 ? _option$Name : '';
            },
            valueFormatter: function (value) {
                var _value$Name;
                return (_value$Name = value === null || value === void 0 ? void 0 : value.Name) !== null && _value$Name !== void 0 ? _value$Name : '';
            },
            valueSetter: function (value, row) {
                var _value$Name2, _value$id3;
                return _objectSpread(_objectSpread({}, row), {}, {
                    PauseReasonName: (_value$Name2 = value === null || value === void 0 ? void 0 : value.Name) !== null && _value$Name2 !== void 0 ? _value$Name2 : null,
                    PauseReasonId: (_value$id3 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id3 !== void 0 ? _value$id3 : null
                });
            },
            valueGetter: function (val, row) {
                var _row$PauseReasonName, _row$PauseReasonId;
                return {
                    Name: (_row$PauseReasonName = row === null || row === void 0 ? void 0 : row.PauseReasonName) !== null && _row$PauseReasonName !== void 0 ? _row$PauseReasonName : null,
                    id: (_row$PauseReasonId = row === null || row === void 0 ? void 0 : row.PauseReasonId) !== null && _row$PauseReasonId !== void 0 ? _row$PauseReasonId : null
                };
            },
            aggregable: false,
            filterOperators: partLabourSearchSelectFilterOperators,
            sortComparator: searchSelectSortComparator
        }, {
            type: 'string',
            field: 'PauseRemarks',
            headerName: 'Pause Remarks',
            minWidth: 250,
            headerAlign: 'left',
            editable: true,
            aggregable: false
        },
        // only UAT v2.5
        // {
        //     type: 'number',
        //     field: 'TradeDiscountPercentage',
        //     headerName: 'Trade Discount (%)',
        //     width: 180,
        //     headerAlign: 'left',
        //     
        // },
        // {
        //     type: 'number',
        //     field: 'TradeDiscountAmount',
        //     headerName: 'Trade Discount (₹)',
        //     width: 180,
        //     headerAlign: 'left',
        //     
        //     valueFormatter: (value) => {
        //         return convertNumberToDecimal(value)
        //     }
        // },
        {
            type: 'number',
            field: 'TaxableAmount',
            headerName: 'Taxable amount (₹)',
            width: 180,
            filterable: false,
            renderCell: function (_ref2) {
                var row = _ref2.row, id = _ref2.id;
                if (id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
                    return undefined;
                }
                return convertNumberToDecimal(row === null || row === void 0 ? void 0 : row.TaxableAmount);
            }
        }, {
            type: 'number',
            field: 'Taxes',
            headerName: 'Taxes (₹)',
            minWidth: 150,
            filterable: false,
            valueGetter: function (value, row) {
                var _row$SavedPriceWithTa2;
                var totalTaxes = row === null || row === void 0 || (_row$SavedPriceWithTa2 = row.SavedPriceWithTax) === null || _row$SavedPriceWithTa2 === void 0 || (_row$SavedPriceWithTa2 = _row$SavedPriceWithTa2.Taxes) === null || _row$SavedPriceWithTa2 === void 0 ? void 0 : _row$SavedPriceWithTa2.reduce(function (sum, component) {
                    return sum + component.TaxComponentAmount;
                }, 0);
                return totalTaxes;
            },
            renderCell: function (_ref3) {
                var row = _ref3.row, id = _ref3.id, value = _ref3.value;
                if (id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
                    return convertNumberToDecimal(Number(value || 0));
                }
                return /*#__PURE__*/ React.createElement(Link, {
                    component: "button",
                    variant: "body1",
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            dispatch(showSurface({
                                type: 'Dialog',
                                Component: TaxDetailsPopup,
                                containerProps: {
                                    fullWidth: true,
                                    maxWidth: 'xs'
                                },
                                componentProps: {
                                    data: row
                                }
                            }));
                            return [2 /*return*/];
                        });
                    }); }
                }, convertNumberToDecimal(Number(value || 0)));
            }
        }, {
            type: 'number',
            field: 'Amount',
            headerName: "Amount (\u20B9)",
            width: 160,
            headerAlign: 'right',
            align: 'right',
            editable: false,
            filterable: false,
            renderCell: function (params) {
                if (params.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
                    return convertNumberToDecimal(params.value);
                }
                // only UAT v2.5
                // const handleOnSubmit = async (ratioData: any) => {
                //     let totalPercent = 0
                //     ratioData?.map((item: any) => {
                //         totalPercent += Number(item?.PercentageValue)
                //     })
                //     if (totalPercent === 100) {
                //         let labourData = crud[JobCardKeys?.Labour]?.data
                //         const newRows: any = labourData?.map((r: ResponseObject) => params?.id === r.id ? { ...r, RatioBilling: ratioData } : r);
                //         dispatch(setReducerState({ key: JobCardKeys?.Labour, value: { data: newRows } }))
                //         await saveRatioBillingDetails(ratioData, params.row)
                //         setLabourModalProps(undefined)
                //     } else {
                //         dispatch(
                //             showNotification({
                //                 isOpen: true,
                //                 message: `Ratio contribution must not exceed/less than 100%.`,
                //                 type: "error",
                //             })
                //         );
                //     }
                // }
                // const handleClickRatioBilling = () => {
                //     const labourModalProps: ResponseObject = {
                //         onSubmit: handleOnSubmit,
                //         rowData: params.row,
                //     };
                //     setLabourModalProps(labourModalProps);
                // };
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'column',
                    justifyContent: 'end'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: '12px'
                }, convertNumberToDecimal(params === null || params === void 0 ? void 0 : params.value)));
            }
        }
        // only UAT v2.5
        // {
        //     field: 'MoreDetails',
        //     headerName: 'More Details',
        //     minWidth: 120,
        //     headerAlign: 'left',
        //     renderCell: (params) => {
        //         if (params?.id === RowModeIds.Aggregation) {
        //             return '';
        //         } else {
        //             return <Link
        //                 disabled={disabled}
        //                 underline="none"
        //                 component="button"
        //                 fontSize='sm'
        //                 fontWeight='medium'
        //                 onClick={async (e) => {
        //                     const res = await dispatch(showSurface({
        //                         type: 'Dialog',
        //                         Component: LabourMoreDetailsPopup,
        //                         containerProps: { fullWidth: true, maxWidth: 'sm' },
        //                         componentProps: {
        //                             data: params?.row,
        //                             wpRequest: {
        //                                 JobCardId: params?.row?.JobCardId,
        //                                 JobCardDetailId: params?.row.JobCardDetailId,
        //                             }
        //                         }
        //                     }));
        //                     // params.api.updateRows([...params?.row, ...res?.payload])
        //                     const updatedRows = currValue?.map((r: GridValidRowModel) => r.id === params.id ? { ...r, ...res.payload } : r)
        //                     onChange?.(e, updatedRows)
        //                 }}
        //             >
        //                 View
        //             </Link>
        //         }
        //     }
        // }
    ];
    var handleRowUpdate = function (newRow, oldRow, params) { return __awaiter(void 0, void 0, void 0, function () {
        var newPrices, _newPrices$, _newPrices$2, _newPrices$3, _newPrices, _newPrices$4, _newPrices$5, _newPrices$6, IGST, CGST, SGST, _newRow$IssuedQuantit, _newRow$CancelQuantit, _newPrice$payload, _newPrice$payload2, newPrice, issuedQty, cancelQty, qty, pendingQty, _newPrice$payload3, _updatedPrice$Taxes, _updatedPrice$Taxes2, _updatedPrice$Taxes3, updatedPrice, IGST, CGST, SGST, _newPrice$payload4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(oldRow.ServiceTypeId !== newRow.ServiceTypeId || oldRow.UnitOfMeasurementId !== newRow.UnitOfMeasurementId)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getPriceDetailsWithTax(_objectSpread(_objectSpread({}, newRow), {}, {
                            SystemName: "Parts"
                        }), documentDetailsGetById)];
                case 1:
                    newPrices = _a.sent();
                    return [4 /*yield*/, getPriceDetailsWithTax(newRow, documentDetailsGetById)];
                case 2:
                    newPrices = _a.sent();
                    if (newPrices) {
                        if (newPrices && newPrices.length > 0) {
                            IGST = (_newPrices$ = newPrices[0]) === null || _newPrices$ === void 0 || (_newPrices$ = _newPrices$.Taxes) === null || _newPrices$ === void 0 ? void 0 : _newPrices$.find(function (item) { return item.TaxComponentName === "IGST"; });
                            CGST = (_newPrices$2 = newPrices[0]) === null || _newPrices$2 === void 0 || (_newPrices$2 = _newPrices$2.Taxes) === null || _newPrices$2 === void 0 ? void 0 : _newPrices$2.find(function (item) { return item.TaxComponentName === "CGST"; });
                            SGST = (_newPrices$3 = newPrices[0]) === null || _newPrices$3 === void 0 || (_newPrices$3 = _newPrices$3.Taxes) === null || _newPrices$3 === void 0 ? void 0 : _newPrices$3.find(function (item) { return item.TaxComponentName === "SGST"; });
                            return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                    PriceWithTaxList: newPrices,
                                    SavedPriceWithTax: (_newPrices = newPrices) === null || _newPrices === void 0 ? void 0 : _newPrices[0],
                                    MRP: newPrices[0].MRP,
                                    TaxableAmount: (_newPrices$4 = newPrices[0]) === null || _newPrices$4 === void 0 ? void 0 : _newPrices$4.TaxableAmount,
                                    Amount: (_newPrices$5 = newPrices[0]) === null || _newPrices$5 === void 0 ? void 0 : _newPrices$5.Amount,
                                    Rate: (_newPrices$6 = newPrices[0]) === null || _newPrices$6 === void 0 ? void 0 : _newPrices$6.Rate,
                                    SGST_UTGST_Amount: SGST ? SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentAmount : 0,
                                    SGST_UTGST_Percentage: SGST ? SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentPercentage : 0,
                                    CGSTAmount: CGST ? CGST.TaxComponentAmount : 0,
                                    CGSTPercentage: CGST ? CGST.TaxComponentPercentage : 0,
                                    IGSTAmount: IGST ? IGST === null || IGST === void 0 ? void 0 : IGST.TaxComponentAmount : 0,
                                    IGSTPercentage: IGST ? IGST.TaxComponentPercentage : 0,
                                    PriceGroupCategoryKey: newPrices[0].PriceGroupCategoryKey || newRow.PriceGroupCategoryKey
                                })];
                        }
                        else {
                            return [2 /*return*/, newRow];
                        }
                    }
                    else {
                        return [2 /*return*/, newRow];
                    }
                    return [3 /*break*/, 5];
                case 3:
                    if (!(oldRow.Rate !== newRow.Rate)) return [3 /*break*/, 5];
                    if (!newRow.Rate) {
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                error: _objectSpread(_objectSpread({}, newRow.error), {}, {
                                    field: 'Rate',
                                    message: 'This field is required'
                                })
                            })];
                    }
                    return [4 /*yield*/, getTax(newRow, documentDetailsGetById)];
                case 4:
                    newPrice = _a.sent();
                    issuedQty = (_newRow$IssuedQuantit = newRow === null || newRow === void 0 ? void 0 : newRow.IssuedQuantity) !== null && _newRow$IssuedQuantit !== void 0 ? _newRow$IssuedQuantit : 0;
                    cancelQty = (_newRow$CancelQuantit = newRow === null || newRow === void 0 ? void 0 : newRow.CancelQuantity) !== null && _newRow$CancelQuantit !== void 0 ? _newRow$CancelQuantit : 0;
                    qty = value - issuedQty;
                    pendingQty = qty - cancelQty;
                    if (newPrice !== null && newPrice !== void 0 && (_newPrice$payload = newPrice.payload) !== null && _newPrice$payload !== void 0 && (_newPrice$payload = _newPrice$payload.value) !== null && _newPrice$payload !== void 0 && _newPrice$payload.data && newPrice !== null && newPrice !== void 0 && (_newPrice$payload2 = newPrice.payload) !== null && _newPrice$payload2 !== void 0 && (_newPrice$payload2 = _newPrice$payload2.value) !== null && _newPrice$payload2 !== void 0 && _newPrice$payload2.success) {
                        updatedPrice = newPrice === null || newPrice === void 0 || (_newPrice$payload3 = newPrice.payload) === null || _newPrice$payload3 === void 0 || (_newPrice$payload3 = _newPrice$payload3.value) === null || _newPrice$payload3 === void 0 ? void 0 : _newPrice$payload3.data;
                        IGST = updatedPrice === null || updatedPrice === void 0 || (_updatedPrice$Taxes = updatedPrice.Taxes) === null || _updatedPrice$Taxes === void 0 ? void 0 : _updatedPrice$Taxes.find(function (item) { return item.TaxComponentName === "IGST"; });
                        CGST = updatedPrice === null || updatedPrice === void 0 || (_updatedPrice$Taxes2 = updatedPrice.Taxes) === null || _updatedPrice$Taxes2 === void 0 ? void 0 : _updatedPrice$Taxes2.find(function (item) { return item.TaxComponentName === "CGST"; });
                        SGST = updatedPrice === null || updatedPrice === void 0 || (_updatedPrice$Taxes3 = updatedPrice.Taxes) === null || _updatedPrice$Taxes3 === void 0 ? void 0 : _updatedPrice$Taxes3.find(function (item) { return item.TaxComponentName === "SGST"; });
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                // PriceWithTaxList: [updatedPrice],
                                IsPriceUpdate: true,
                                SavedPriceWithTax: _objectSpread(_objectSpread({}, newRow.SavedPriceWithTax), {}, {
                                    "Taxes": updatedPrice.Taxes,
                                    "Rate": updatedPrice.Rate,
                                    "Quantity": updatedPrice.Quantity,
                                    "Amount": updatedPrice.Amount,
                                    "TaxableAmount": updatedPrice.TaxableAmount,
                                    "BaseAmount": updatedPrice.BaseAmount
                                }),
                                OriginalPrice: newRow !== null && newRow !== void 0 && newRow.OriginalPrice ? newRow === null || newRow === void 0 ? void 0 : newRow.OriginalPrice : oldRow.Rate,
                                MRP: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.MRP,
                                TaxableAmount: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.TaxableAmount,
                                Amount: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.Amount,
                                Rate: updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.Rate,
                                SGST_UTGST_Amount: SGST ? SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentAmount : 0,
                                SGST_UTGST_Percentage: SGST ? SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentPercentage : 0,
                                CGSTAmount: CGST ? CGST.TaxComponentAmount : 0,
                                CGSTPercentage: CGST ? CGST.TaxComponentPercentage : 0,
                                IGSTAmount: IGST ? IGST === null || IGST === void 0 ? void 0 : IGST.TaxComponentAmount : 0,
                                IGSTPercentage: IGST ? IGST.TaxComponentPercentage : 0,
                                PriceGroupCategoryKey: updatedPrice.PriceGroupCategoryKey || newRow.PriceGroupCategoryKey,
                                PendingQuantity: pendingQty >= 0 ? pendingQty : 0,
                                error: undefined
                            })];
                    }
                    else {
                        return [2 /*return*/, _objectSpread(_objectSpread({}, newRow), {}, {
                                error: _objectSpread(_objectSpread({}, newRow.error), {}, {
                                    field: 'Rate',
                                    message: newPrice === null || newPrice === void 0 || (_newPrice$payload4 = newPrice.payload) === null || _newPrice$payload4 === void 0 || (_newPrice$payload4 = _newPrice$payload4.value) === null || _newPrice$payload4 === void 0 ? void 0 : _newPrice$payload4.message
                                })
                            })];
                    }
                    _a.label = 5;
                case 5: return [2 /*return*/, newRow];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Labour",
        isCollapsible: true,
        disableDeleteRow: disabled,
        columns: labourColumns,
        disableAddRow: false,
        validationModel: {
            Rate: function (currValue, row) {
                var MaxLimit = null;
                if (row.MaxPrice !== null && row.MaxPrice !== undefined) {
                    MaxLimit = row.MaxPrice;
                }
                else if (row.OriginalPrice !== null && row.OriginalPrice !== undefined) {
                    MaxLimit = row.OriginalPrice;
                }
                else {
                    var _row$SavedPriceWithTa3;
                    MaxLimit = (_row$SavedPriceWithTa3 = row.SavedPriceWithTax) === null || _row$SavedPriceWithTa3 === void 0 ? void 0 : _row$SavedPriceWithTa3.Rate;
                }
                if (currValue != 0 && !currValue) {
                    return "This field is required";
                }
                if ((row === null || row === void 0 ? void 0 : row.EditableRange) === 1) {
                    if ((row === null || row === void 0 ? void 0 : row.MinPrice) !== null && row.MinPrice !== undefined && currValue < (row === null || row === void 0 ? void 0 : row.MinPrice)) {
                        return "Rate should be more than ".concat(row === null || row === void 0 ? void 0 : row.MinPrice);
                    }
                }
                if ((row === null || row === void 0 ? void 0 : row.EditableRange) === 2) {
                    if (row !== null && row !== void 0 && row.MaxLimit && currValue > (row === null || row === void 0 ? void 0 : row.MaxLimit)) {
                        return "Rate should be less than ".concat(MaxLimit);
                    }
                }
                if (row.EditableRange === 0) {
                    if ((row === null || row === void 0 ? void 0 : row.MinPrice) !== null && row.MinPrice !== undefined && (currValue < (row === null || row === void 0 ? void 0 : row.MinPrice) || currValue > MaxLimit)) {
                        return "Enter rate between ".concat(row === null || row === void 0 ? void 0 : row.MinPrice, " & ").concat(MaxLimit);
                    }
                }
                if (!REG.validateDecimalAndNonNumeric.test(currValue) && currValue !== "") {
                    return "Up to 2 decimal precision is allowed";
                }
                return "";
            },
            ServiceTypeName: function (currValue, row) {
                return !currValue ? GridValidations.JOB_TYPE_REQUIRED : '';
            },
            TechnicianName: function (currValue, row) {
                var message = '';
                if (!currValue) {
                    if ((row === null || row === void 0 ? void 0 : row.StatusName) === StatusEnum.Started) {
                        return "You cannont clear 'Technician Name' since status is started.";
                    }
                    if ((row === null || row === void 0 ? void 0 : row.StatusName) === StatusEnum.Completed) {
                        return GridValidations.WORK_COMPLETED;
                    }
                    if ((row === null || row === void 0 ? void 0 : row.StatusName) === StatusEnum.Pause) {
                        return GridValidations.LABOUR_PAUSED;
                    }
                    return message;
                }
                if ((currValue === null || currValue === void 0 ? void 0 : currValue.id) === (row === null || row === void 0 ? void 0 : row.TechnicianId))
                    return message;
                switch (row === null || row === void 0 ? void 0 : row.StatusName) {
                    case StatusEnum.Completed:
                        message = GridValidations.WORK_COMPLETED;
                        break;
                    case StatusEnum.Pause:
                        message = GridValidations.LABOUR_PAUSED;
                        break;
                    default:
                        if (!(row !== null && row !== void 0 && row.HSNSACCode))
                            message = GridValidations.SAC_REQUIRED;
                        break;
                }
                return message;
            },
            Quantity: function (currValue, row) {
                var message = '';
                if (!currValue)
                    return message;
                switch (row === null || row === void 0 ? void 0 : row.StatusName) {
                    case StatusEnum.Completed:
                        message = GridValidations.WORK_COMPLETED;
                        ;
                        break;
                    case StatusEnum.Pause:
                        message = GridValidations.LABOUR_PAUSED;
                        ;
                        break;
                    default:
                        if (!(row !== null && row !== void 0 && row.HSNSACCode))
                            message = GridValidations.SAC_REQUIRED;
                        break;
                }
                return message;
            },
            ServiceStartDateTime: function (currValue, row) {
                var _dayjs;
                var message = '';
                var previousStartDate = dayjs(row === null || row === void 0 ? void 0 : row.ServiceStartDateTime);
                var currStartDate = dayjs(currValue);
                if (!currValue) {
                    if ((row === null || row === void 0 ? void 0 : row.StatusName) === StatusEnum.Start) {
                        return "You cannot clear the 'Date and time' since work is already started.";
                    }
                    if ((row === null || row === void 0 ? void 0 : row.StatusName) === StatusEnum.Pause) {
                        return "You cannot clear the 'Date and time' since work is paused.";
                    }
                    if ((row === null || row === void 0 ? void 0 : row.StatusName) === StatusEnum.Completed) {
                        return "You cannot clear the 'Date and time' since work is completed.";
                    }
                    return message;
                }
                switch (row === null || row === void 0 ? void 0 : row.StatusName) {
                    case StatusEnum.Completed:
                        if (currStartDate !== null && currStartDate !== void 0 && currStartDate.isSame(previousStartDate, 'minute')) {
                            return message;
                        }
                        message = "You cannot change the 'Date and time' since work is completed. ( Start time: ".concat(previousStartDate && (previousStartDate === null || previousStartDate === void 0 ? void 0 : previousStartDate.format('DD MMM, YYYY h:mm A')), " )");
                        break;
                    case StatusEnum.Pause:
                        if (currStartDate !== null && currStartDate !== void 0 && currStartDate.isSame(previousStartDate, 'minute')) {
                            return message;
                        }
                        message = "You cannot change the 'Date and time' since work is paused. ( Start time: ".concat(previousStartDate && (previousStartDate === null || previousStartDate === void 0 ? void 0 : previousStartDate.format('DD MMM, YYYY h:mm A')), " )");
                        break;
                    case StatusEnum.Awaiting:
                        message = GridValidations.LABOUR_AWAITING;
                        break;
                    default:
                        if (!(row !== null && row !== void 0 && row.HSNSACCode))
                            message = GridValidations.SAC_REQUIRED;
                        if ((_dayjs = dayjs(currValue)) !== null && _dayjs !== void 0 && _dayjs.isBefore(dayjs(row === null || row === void 0 ? void 0 : row.JCCreationDate)))
                            message = "Start date time should be greater than document creation date time.";
                        if (dayjs(currValue).isAfter(dayjs()))
                            message = "Labor start date time can not be greater than actual date time.";
                        break;
                }
                return message;
            },
            ServiceEndDateTime: function (currValue, row) {
                var _dayjs2;
                var message = '';
                var previousEndDate = dayjs(row === null || row === void 0 ? void 0 : row.ServiceEndDateTime);
                var currEndDate = dayjs(currValue);
                if (!currValue) {
                    if ((row === null || row === void 0 ? void 0 : row.StatusName) === StatusEnum.Pause) {
                        return "You cannot clear the 'Date and time' since work is paused.";
                    }
                    if ((row === null || row === void 0 ? void 0 : row.StatusName) === StatusEnum.Completed) {
                        return "You cannot clear the 'Date and time' since work is completed.";
                    }
                    return message;
                }
                if (!currValue)
                    return message;
                switch (row === null || row === void 0 ? void 0 : row.StatusName) {
                    case StatusEnum.Completed:
                        if (currEndDate !== null && currEndDate !== void 0 && currEndDate.isSame(previousEndDate, 'minute')) {
                            return message;
                        }
                        message = "You cannot change the 'Date and time' since work is completed. ( End time: ".concat(previousEndDate && (previousEndDate === null || previousEndDate === void 0 ? void 0 : previousEndDate.format('DD MMM, YYYY h:mm A')), " )");
                        break;
                    case StatusEnum.Pause:
                        if (currEndDate !== null && currEndDate !== void 0 && currEndDate.isSame(previousEndDate, 'minute')) {
                            return message;
                        }
                        message = "You cannot change the 'Date and time' since work is paused. ( End time: ".concat(previousEndDate && (previousEndDate === null || previousEndDate === void 0 ? void 0 : previousEndDate.format('DD MMM, YYYY h:mm A')), " )");
                        break;
                    case StatusEnum.Awaiting:
                        message = GridValidations.LABOUR_AWAITING;
                        break;
                    case StatusEnum.Start:
                        message = GridValidations.DATE_VALIDATION;
                        break;
                    default:
                        if (!(row !== null && row !== void 0 && row.HSNSACCode))
                            message = GridValidations.SAC_REQUIRED;
                        if ((_dayjs2 = dayjs(currValue)) !== null && _dayjs2 !== void 0 && _dayjs2.isBefore(dayjs(row === null || row === void 0 ? void 0 : row.ServiceStartDateTime), 'minute')) {
                            message = "End date time cannot be earlier than start date time";
                        }
                        else if (dayjs(currValue).isAfter(dayjs(), 'minute') && !dayjs(currValue).isSame(dayjs(), 'day')) {
                            message = "Post dated transaction not allowed";
                        }
                        break;
                }
                return message;
            },
            Description: function (currValue, row) {
                var message = '';
                if (!currValue)
                    return message;
                switch (row === null || row === void 0 ? void 0 : row.StatusName) {
                    case StatusEnum.Completed:
                        message = GridValidations.WORK_COMPLETED;
                        ;
                        break;
                    case StatusEnum.Pause:
                        message = GridValidations.LABOUR_PAUSED;
                        ;
                        break;
                    default:
                        if (!(row !== null && row !== void 0 && row.HSNSACCode))
                            message = GridValidations.SAC_REQUIRED;
                        break;
                }
                return message;
            },
            StatusId: function (currValue, row) {
                var message = '';
                if (!currValue)
                    return "You cannont leave 'Status' blank since it is mandatory.";
                else if ((currValue === null || currValue === void 0 ? void 0 : currValue.Key) === StatusEnum.Awaiting) {
                    message = '';
                }
                // else if (!row?.TechnicianId && currValue?.Key === StatusEnum.Pause) {
                //     message = 'Please select technician before pause the work.';
                // }
                // else if (!row?.TechnicianId && currValue?.Key === StatusEnum.Start) {
                //     message = 'Please select technician before starting the work.';
                // }
                // else if (!row?.TechnicianId && currValue?.Key === StatusEnum.Completed) {
                //     message = 'Please select technician before completing the work.';
                // }
                else if (!(row !== null && row !== void 0 && row.HSNSACCode)) {
                    message = GridValidations.SAC_REQUIRED;
                }
                else if (!(row !== null && row !== void 0 && row.TechnicianName) && (currValue === null || currValue === void 0 ? void 0 : currValue.Key) !== StatusEnum.Awaiting) {
                    message = GridValidations.MECHANIC_NOT_ALLOCATED;
                }
                else if (!(row !== null && row !== void 0 && row.ServiceTypeName) && (currValue === null || currValue === void 0 ? void 0 : currValue.Key) !== StatusEnum.Awaiting) {
                    message = GridValidations.JOB_TYPE_REQUIRED;
                }
                return message;
            },
            PauseRemarks: function (currValue, row) {
                var message = '';
                if (!currValue)
                    return message;
                switch (row === null || row === void 0 ? void 0 : row.StatusName) {
                    case StatusEnum.Pause:
                        if (!currValue)
                            return "You cannont leave 'Pause remark' blank since it is mandatory.";
                        if ((currValue === null || currValue === void 0 ? void 0 : currValue.length) > 200) {
                            return "Maximum allowed limit is 200";
                        }
                        else {
                            return '';
                        }
                    default:
                        if (currValue)
                            return "You cannot set 'Pause Remark' as status is not pause.";
                        break;
                }
                return message;
            },
            PauseReasonName: function (currValue, row) {
                var message = '';
                if (!currValue)
                    return message;
                switch (row === null || row === void 0 ? void 0 : row.StatusName) {
                    case StatusEnum.Pause:
                        if (!currValue)
                            return "You cannont leave 'Pause Reason' blank since it is mandatory.";
                        break;
                    default:
                        if (currValue)
                            return "You cannot set 'Pause Reason' as status is not pause.";
                        break;
                }
                return message;
            }
        },
        dataGridProps: {
            processRowUpdate: handleRowUpdate,
            initialState: {
                pinnedColumns: {
                    left: ['__check__', 'ChildName'],
                    right: ['StatusId', 'MoreDetails']
                },
                aggregation: {
                    model: {
                        Quantity: 'sum',
                        TaxableAmount: 'sum',
                        TradeDiscountAmount: 'sum',
                        TaxAmount: 'sum',
                        Taxes: 'sum',
                        Amount: 'sum'
                    }
                }
            },
            isCellEditable: function (params) {
                if (disabled)
                    return false;
                if ((params === null || params === void 0 ? void 0 : params.field) == 'ReworkStartDateTime' || (params === null || params === void 0 ? void 0 : params.field) == 'ReworkEndDateTime') {
                    var _params$row9;
                    if ((params === null || params === void 0 || (_params$row9 = params.row) === null || _params$row9 === void 0 ? void 0 : _params$row9.LabourStatus) === 'Rework') {
                        return true;
                    }
                    return false;
                }
                if ((params === null || params === void 0 ? void 0 : params.field) === "Rate") {
                    var _params$row10;
                    return params === null || params === void 0 || (_params$row10 = params.row) === null || _params$row10 === void 0 || (_params$row10 = _params$row10.SavedPriceWithTax) === null || _params$row10 === void 0 ? void 0 : _params$row10.IsRateEditable;
                }
                // if (params?.field === "ServiceStartDateTime" || params?.field === "ServiceEndDateTime") {
                //     return params?.row?.StatusName !== StatusEnum.Completed
                // }
                var formFields = ["ServiceTypeName", "TechnicianName", "Quantity", "ServiceStartDateTime", "ServiceEndDateTime", "Description", "StatusId", "MoreDetails"];
                return formFields !== null && formFields !== void 0 && formFields.includes(params === null || params === void 0 ? void 0 : params.field) ? !disabled : true;
            },
            hideFooter: true,
            checkboxSelection: !disabled,
            disableRowSelectionOnClick: true,
            disableRowGrouping: true,
            getRowHeight: function (params) {
                return params.id === 'total' ? 44 : undefined;
            },
            onCellEditStart: function () {
                dispatch(setReducerState({
                    key: JobCardKeys.DisableSubmit,
                    value: true
                }));
            },
            onCellEditStop: function () {
                dispatch(setReducerState({
                    key: JobCardKeys.DisableSubmit,
                    value: false
                }));
            },
            onCellClick: function (_ref4, e, _ref5) {
                var id = _ref4.id, field = _ref4.field, isEditable = _ref4.isEditable, cellMode = _ref4.cellMode;
                var api = _ref5.api;
                if (isEditable && cellMode === 'view') {
                    api === null || api === void 0 || api.startCellEditMode({
                        id: id,
                        field: field
                    });
                    dispatch(setReducerState({
                        key: JobCardKeys.DisableSubmit,
                        value: true
                    }));
                }
            },
            getCellClassName: function (params) {
                return !params.isEditable ? "".concat(gridClasses.cell, "--disabled") : "";
            },
            sx: (_a = {},
                _a[".".concat(gridClasses.cell, "--disabled")] = {
                    bgcolor: 'secondary.50'
                },
                _a[".".concat(gridClasses["cell--editable"])] = {
                    cursor: 'pointer'
                },
                _a)
        },
        rows: currValue || [],
        onChange: onChange,
        error: error === null || error === void 0 ? void 0 : error[name],
        getToolbarActions: function (params) { return __spreadArray([{
                type: 'Button',
                label: 'CompleteAll',
                name: 'completeAll',
                children: 'Complete All',
                checked: true,
                variant: 'outlined',
                disabled: disabled,
                color: 'primary'
            }, {
                type: 'Button',
                label: 'StartAll',
                name: 'startAll',
                children: 'Start All',
                checked: true,
                variant: 'outlined',
                disabled: disabled,
                color: 'primary'
            }, {
                type: 'IconButton',
                name: "delete",
                label: 'Delete',
                children: /*#__PURE__*/ React.createElement(DeleteSvgIcon, {
                    fontSize: "small"
                }),
                checked: true
                // disabled: getConfigurationValue(JobCardKeys.ToAllowUserRemoveLineLEevelJobCard)
            }], EditableGridActions.filter(function (Obj) { return !['add', 'upload', 'delete'].includes(Obj.name); }), true); },
        onToolbarButtonClick: function (e, params) { return __awaiter(void 0, void 0, void 0, function () {
            var _params$rows, _params$rows2, _params$rows3, _params$rows4, _params$rows5, updatedAllList, _params$rows6, _params$rows7, _params$rows8, _params$rows9, _params$rows10, updatedAllList, _params$api, selectedRows_1, updatedAllList, req, validateResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (e.currentTarget.id === 'completeAll') {
                            if ((params === null || params === void 0 || (_params$rows = params.rows) === null || _params$rows === void 0 ? void 0 : _params$rows.length) === 0) {
                                return [2 /*return*/, dispatch(showNotification({
                                        isOpen: true,
                                        message: "You can not complete all labour since no labour is present at service line.",
                                        type: "error"
                                    }))];
                            }
                            else if (params !== null && params !== void 0 && (_params$rows2 = params.rows) !== null && _params$rows2 !== void 0 && _params$rows2.some(function (it) { return !(it !== null && it !== void 0 && it.TechnicianName); })) {
                                return [2 /*return*/, dispatch(showNotification({
                                        isOpen: true,
                                        message: "Technician assignment is required before changing service status.",
                                        type: "error"
                                    }))];
                            }
                            else if (params !== null && params !== void 0 && (_params$rows3 = params.rows) !== null && _params$rows3 !== void 0 && _params$rows3.some(function (it) { return !(it !== null && it !== void 0 && it.ServiceTypeName); })) {
                                return [2 /*return*/, dispatch(showNotification({
                                        isOpen: true,
                                        message: "You cannot complete all labour since job type is missing in some of the service line labour.",
                                        type: "error"
                                    }))];
                            }
                            else if (params !== null && params !== void 0 && (_params$rows4 = params.rows) !== null && _params$rows4 !== void 0 && _params$rows4.some(function (it) { return !(it !== null && it !== void 0 && it.HSNSACCode); })) {
                                return [2 /*return*/, dispatch(showNotification({
                                        isOpen: true,
                                        message: "You cannot complete all labour since SAC code is missing in some of the service line labour.",
                                        type: "error"
                                    }))];
                            }
                            updatedAllList = params === null || params === void 0 || (_params$rows5 = params.rows) === null || _params$rows5 === void 0 ? void 0 : _params$rows5.map(function (item) {
                                var _getStatus;
                                var isNotCompleted = (item === null || item === void 0 ? void 0 : item.StatusName) !== StatusEnum.Completed;
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    ServiceEndDateTime: (item === null || item === void 0 ? void 0 : item.StatusName) !== StatusEnum.Pause ? item !== null && item !== void 0 && item.ServiceEndDateTime ? item === null || item === void 0 ? void 0 : item.ServiceEndDateTime : dayjs() : dayjs(),
                                    ServiceStartDateTime: item !== null && item !== void 0 && item.ServiceStartDateTime ? item === null || item === void 0 ? void 0 : item.ServiceStartDateTime : dayjs(),
                                    StatusId: (_getStatus = getStatus(StatusEnum.Completed)) === null || _getStatus === void 0 ? void 0 : _getStatus.id,
                                    StatusKey: StatusEnum.Completed,
                                    StatusName: StatusEnum.Completed,
                                    PauseRemarks: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseRemarks,
                                    PauseReasonName: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseReasonName,
                                    PauseReasonId: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseReasonId
                                });
                            });
                            onChange === null || onChange === void 0 || onChange(e, updatedAllList);
                        }
                        if (e.currentTarget.id === 'startAll') {
                            if ((params === null || params === void 0 || (_params$rows6 = params.rows) === null || _params$rows6 === void 0 ? void 0 : _params$rows6.length) === 0) {
                                return [2 /*return*/, dispatch(showNotification({
                                        isOpen: true,
                                        message: "You can not start all labour since no labour is present at service line.",
                                        type: "error"
                                    }))];
                            }
                            else if (params !== null && params !== void 0 && (_params$rows7 = params.rows) !== null && _params$rows7 !== void 0 && _params$rows7.some(function (it) { return !(it !== null && it !== void 0 && it.TechnicianName); })) {
                                return [2 /*return*/, dispatch(showNotification({
                                        isOpen: true,
                                        message: "Technician assignment is required before changing service status.",
                                        type: "error"
                                    }))];
                            }
                            else if (params !== null && params !== void 0 && (_params$rows8 = params.rows) !== null && _params$rows8 !== void 0 && _params$rows8.some(function (it) { return !(it !== null && it !== void 0 && it.ServiceTypeName); })) {
                                return [2 /*return*/, dispatch(showNotification({
                                        isOpen: true,
                                        message: "You cannot start all labour since job type is missing in some of the service line labour.",
                                        type: "error"
                                    }))];
                            }
                            else if (params !== null && params !== void 0 && (_params$rows9 = params.rows) !== null && _params$rows9 !== void 0 && _params$rows9.some(function (it) { return !(it !== null && it !== void 0 && it.HSNSACCode); })) {
                                return [2 /*return*/, dispatch(showNotification({
                                        isOpen: true,
                                        message: "You cannot start all labour since SAC code is missing in some of the service line labour.",
                                        type: "error"
                                    }))];
                            }
                            updatedAllList = params === null || params === void 0 || (_params$rows10 = params.rows) === null || _params$rows10 === void 0 ? void 0 : _params$rows10.map(function (item) {
                                var _getStatus2, _getStatus3;
                                var isNotCompleted = (item === null || item === void 0 ? void 0 : item.StatusName) !== StatusEnum.Completed;
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    ServiceStartDateTime: (item === null || item === void 0 ? void 0 : item.StatusName) === StatusEnum.Pause ? dayjs() : (item === null || item === void 0 ? void 0 : item.StatusName) === StatusEnum.Completed || item !== null && item !== void 0 && item.ServiceStartDateTime ? item === null || item === void 0 ? void 0 : item.ServiceStartDateTime : dayjs(),
                                    StatusName: isNotCompleted ? StatusEnum.Started : item === null || item === void 0 ? void 0 : item.StatusName,
                                    StatusId: isNotCompleted ? (_getStatus2 = getStatus(StatusEnum.Start)) === null || _getStatus2 === void 0 ? void 0 : _getStatus2.id : (_getStatus3 = getStatus(item === null || item === void 0 ? void 0 : item.StatusName)) === null || _getStatus3 === void 0 ? void 0 : _getStatus3.id,
                                    StatusKey: isNotCompleted ? StatusEnum.Started : item === null || item === void 0 ? void 0 : item.StatusKey,
                                    ServiceEndDateTime: isNotCompleted ? null : item !== null && item !== void 0 && item.ServiceEndDateTime ? item === null || item === void 0 ? void 0 : item.ServiceEndDateTime : dayjs(),
                                    PauseRemarks: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseRemarks,
                                    PauseReasonName: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseReasonName,
                                    PauseReasonId: isNotCompleted ? null : item === null || item === void 0 ? void 0 : item.PauseReasonId
                                });
                            });
                            onChange === null || onChange === void 0 || onChange(e, updatedAllList);
                        }
                        if (!(e.currentTarget.id === 'delete')) return [3 /*break*/, 2];
                        selectedRows_1 = params === null || params === void 0 || (_params$api = params.api) === null || _params$api === void 0 || (_params$api = _params$api.current) === null || _params$api === void 0 ? void 0 : _params$api.getSelectedRows();
                        updatedAllList = currValue.map(function (item) {
                            var isSelected = selectedRows_1 === null || selectedRows_1 === void 0 ? void 0 : selectedRows_1.has(item.id);
                            if (isSelected) {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    "UserDeleted": true,
                                    "IsActive": false,
                                    "IsDeleted": true
                                });
                            }
                            else {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    "UserDeleted": false
                                });
                            }
                        });
                        req = {
                            "SystemName": "Labours",
                            "Labours": updatedAllList
                        };
                        return [4 /*yield*/, validateDeletePartLabour({
                                request: req
                            })];
                    case 1:
                        validateResponse = _a.sent();
                        if (validateResponse.success && validateResponse.statusCode === 200) {
                            onChange === null || onChange === void 0 || onChange(e, updatedAllList);
                        }
                        return [2 /*return*/, false];
                    case 2: return [2 /*return*/, true];
                }
            });
        }); }
    }));
};
export default JobcardLabourGrid;
